module.exports = __webpack_public_path__ + "workspace/static/img/download-center-beta-two.7537879.png";